import React from "react";

const HeaderBannerSkeleton = () => {
  return (
    <section>
      <div className="relative md:mt-[0px]">
        <div className="bg-neutral-200 w-full min-h-[330px] md:min-h-[380px] xl:max-h-[320px] object-cover object-centen"></div>
        <div className="absolute top-[0] w-full py-[16px] md:py-[24px] h-full">
          <div className="max-w-container mx-auto h-full px-[16px] md:px-[20px] xl:px-[0]">
            <div className="flex flex-col h-full w-full justify-between">
              <div className="flex justify-end w-full">
                <button className="small font-semibold hover:underline flex gap-[6px] px-[10px] py-[6px] rounded-[16px] bg-grey-100 text-grey-500">
                  <div className="skeleton skeleton-text-animated descrip !w-[100px]"></div>
                </button>
              </div>
              <div className="flex md:flex-col xl:flex-row justify-between">
                <div className="flex items-start flex-col xl:flex-row gap-[16px] md:w-[45%]">
                  <span className="p-[4px] bg-neutral-300 skeleton-text-animated rounded-[12px] shadow-custom-1 w-[64px] md:min-w-[64px] h-[64px] md:w-[100px] md:h-[100px]"></span>
                  <div className="text-white flex flex-col gap-[4px] md:w-[70%]">
                    <div className="skeleton skeleton-text-animated large_heading !mt-0"></div>

                    <span className="para font-semibold text-white">
                      <div className="skeleton skeleton-text-animated heading !mt-0"></div>
                    </span>
                    <div className="small">
                      <span className="flex items-center">
                        <div className="skeleton skeleton-text-animated descrip !w-[100%] !mt-0"></div>
                      </span>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] mt-[4px] md:mt-[0]">
                      <li className="flex text-nowrap select-none rounded-[4px] font-bold uppercase px-[8px] text-positive-dark xs-small skeleton skeleton-square-img skeleton-text-animated !w-[105px] !h-[20px] !rounded-[4px] !m-0"></li>
                      <li className="flex text-nowrap select-none rounded-[4px] font-bold uppercase px-[8px]  text-positive-dark xs-small skeleton skeleton-square-img skeleton-text-animated !w-[150px] !h-[20px] !rounded-[4px] !m-0"></li>
                    </ul>
                  </div>
                </div>
                <div className="flex xl:pt-[0] gap-[8px] items-end lg:min-w-[630px] md:pt-[12px]">
                  <div className="bg-grey100 xl:bg-transparent flex items-end p-[16px] md:p-[0] gap-[8px] hidden md:flex grid md:flex grid-cols-2 w-full  left-[0px] md:left-[0px] md:top-[unset] absolute md:relative md:p-[0px] grid-cols-2">
                    <div className="skeleton skeleton_btn skeleton-text-animated !w-[137px] !m-0"></div>
                    <div className="skeleton skeleton_btn skeleton-text-animated !w-[137px] !m-0"></div>
                    <div className="skeleton skeleton_btn skeleton-text-animated !w-[137px] !m-0"></div>
                    <div className="skeleton skeleton_btn skeleton-text-animated !w-[137px] !m-0"></div>
                  </div>
                  <button className="favorite group items-center justify-center flex min-w-[40px] w-[40px] h-[40px]  border border-primary-400 hover:bg-primary-400 rounded-[48px] cursor-pointer">
                    <div className="min-w-[40px] w-[40px] h-[40px] bg-neutral-200 border border-neutral-300 rounded-[24px] flex items-center justify-center cursor-pointer">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.02513 5.05027C2.65829 6.41711 2.65829 8.63318 4.02513 10L10 15.9749L15.9749 10C17.3417 8.63318 17.3417 6.41711 15.9749 5.05027C14.608 3.68344 12.392 3.68344 11.0251 5.05027L10 6.07544L8.97487 5.05027C7.60804 3.68344 5.39196 3.68344 4.02513 5.05027Z"
                          stroke="#d4d4d4"
                          strokeWidth="1.67"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeaderBannerSkeleton;
